export default "__VITE_ASSET__D2HAv6UA__"